<template>
<div class="container-fluid">
<collapsible-panel panel-size="lg" :external-toggle="!isComplete && !isShareLink" style="margin-top: -25px;">
	<template slot="panel">
		<h3>Progress</h3>

		<ol class="list-group">
			<li v-for="(section,index) in sections" class="list-group-item" :class="{
					active: activeSecIndex == index,
					disabled: (index > subscribeSectionIndex && !hasPaidSubscription) || (index > onboardingPackageSectionIndex && !hasOnboardingPackage)
				}">

				<h4><a href="#" v-on:click.prevent="setQuestion(index,0)" class="d-flex"><span class="mr-1">{{index+1}}.</span> <span>{{ section.sectionHeading }}</span></a></h4>
				<ol v-if="'questions' in section" style="list-style-type: lower-alpha;">
					<li v-for="(q,qIndex) in section.questions" :class="{
							active: qIndex == activeQIndex && activeSecIndex == index,
						}">

						<template v-if="index == activeSecIndex && qIndex == activeQIndex" href="#">{{q.question}}</template>
						<a href="#" v-else v-on:click.prevent="setQuestion(index,qIndex)">{{q.question}}</a>
					</li>
				</ol>
			</li>
		</ol>
	</template>
	<template slot="main">
		<section v-if="isComplete" class="wizard-section">
			<div class="text-center alert alert-success">
				<i class="fa fa-3x fa-check-circle"></i>

				<h2>You're all set up!</h2>

				<div v-if="completeMessage" v-html="completeMessage" style="font-size: 16pt;font-weight: 300;"></div>
				<p v-else style="font-size: 16pt;font-weight: 300;">This completes the setup process. Everything you may want to do will always be available in the main sidebar menu to the left. And if you would like to change any of these set-up options, just go the <router-link to="/settings">Settings</router-link> menu.</p>

				<p><a href='#' v-on:click="isComplete = false;$store.companySetupMode = false">Go back to wizard</a></p>
			</div>
		</section>
		<section v-else class="wizard-section">

			<div v-if="$store.tokenExpiry" class="text-danger text-center">This page has been shared with you. Access expires in {{ tokenExpiryTime }}</div>

			<div class="d-flex flex-row justify-content-between">
				<h2>{{ activeSecIndex+1 }}. {{ sections[activeSecIndex].sectionHeading }}</h2>

				<div v-if="!isShareLink" class="mb-2">
					<a v-if="!sections[activeSecIndex].sharing" href="#" v-on:click.prevent="shareSection(activeSecIndex)">Share section link...</a>
					<div v-else>
						
						<div class="d-flex">
							<field v-model="sections[activeSecIndex].sharing"></field>
							<button type="button" class="btn btn-light" v-on:click="copyToClipboard(sections[activeSecIndex].sharing,true)"><i class="fa fa-copy"></i></button>
						</div>
	
						<span class="text-danger">This link will expire in 48 hrs</span>
					</div>
				</div>
			</div>

			<div v-if="'intro' in sections[activeSecIndex]" class="alert alert-info">
				<i class="fa fa-info-circle"></i>
				<p style="font-size: 16pt;font-weight: 300;" v-html="sections[activeSecIndex].intro"></p>
			</div>

			<section v-if="'questions' in sections[activeSecIndex]">
				<div v-if="'conditionalAnswer' in sections[activeSecIndex].questions[activeQIndex] && sections[activeSecIndex].questions[activeQIndex].conditionalAnswer == null">

					<h3>{{ sections[activeSecIndex].questions[activeQIndex].conditionalQuestion }}</h3>

					<div class="d-flex flex-row justify-content-center">
						<button class="btn btn-lg btn-light m-1" v-on:click="sections[activeSecIndex].questions[activeQIndex].conditionalAnswer = true">
							YES
						</button>
						<button class="btn btn-lg btn-light m-1" v-on:click="nextQuestion(true)">
							NO
						</button>
					</div>
					
				</div>
				<div v-else>

					<p><a href="#" v-on:click.prevent="sections[activeSecIndex].questions[activeQIndex].conditionalAnswer = null">I don't need this section</a></p>

					<div class="d-flex justify-content-between align-items-center">
						<h3>{{ sections[activeSecIndex].questions[activeQIndex].question }}</h3>

						<div>
							<button v-if="'questionButton' in sections[activeSecIndex].questions[activeQIndex] && sections[activeSecIndex].questions[activeQIndex].questionButton" 
								class="btn btn-light"
								v-on:click="sections[activeSecIndex].questions[activeQIndex].questionButton.clickFunction">
								{{ sections[activeSecIndex].questions[activeQIndex].questionButton.buttonText }}
							</button>
						</div>
					</div>


					<div v-for="field in sections[activeSecIndex].questions[activeQIndex].fields">

						<upload-field-with-panel v-if="'params' in field && field.params && 'type' in field.params && field.params.type == 'image'"
							v-model="sections[activeSecIndex].questions[activeQIndex].payload[field.vmodel]"
							:api-model="field.params.apiResource"
							upload-type="image"
							v-on:uploaded="imageUploaded($event,sections[activeSecIndex].questions[activeQIndex].payload,field)">
						</upload-field-with-panel>

						<field v-else
							:key="field.vmodel"
							:label="'label' in field ? field.label : ''"
							col-class="stacked"
							v-model="sections[activeSecIndex].questions[activeQIndex].payload[field.vmodel]"
							:params="field.params">
						</field>	
					</div>
				</div>

			</section>

			<slot></slot>

			<div v-if="!isShareLink" class="d-flex flex-row justify-content-between">
				<div>
					<button v-if="activeSecIndex > 0 || activeQIndex > 0" class="btn btn-light" v-on:click="previousQuestion">
						<i class="fa fa-chevron-left"></i>
						Previous
					</button>
				</div>
				<div v-if="!('mandatory' in sections[activeSecIndex]) || sections[activeSecIndex].mandatory.value == sections[activeSecIndex].mandatory.equals">
					<template v-if="showNextButton">
						<button v-if="!('hideSkip' in sections[activeSecIndex])" class="btn btn-light" type="button" v-on:click="nextQuestion(true)">
							Skip
							<i class="fa fa-angle-double-right"></i>
						</button>
						<button class="btn btn-success" v-on:click="nextQuestion(false)">
							{{ 'nextButtonText' in sections[activeSecIndex] ? sections[activeSecIndex].nextButtonText : 'Save & Next' }}
							<i class="fa fa-chevron-right"></i>
						</button>
					</template>
					<button v-else class="btn btn-success btn-lg" v-on:click="finishWizard">
						<i class="fa fa-check-circle"></i>
						Finish Setup
					</button>
				</div>
			</div>
			<div v-else>
				<button v-if="sectionHasSave" class="btn btn-success float-right" v-on:click="saveQuestion(activeSecIndex,activeQIndex)">
					Save
				</button>
				<div style="clear: both;"></div>
			</div>
		</section>
	</template>
</collapsible-panel>
</div>
</template>
<script type="text/javascript">
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import Field from "@/components/Field"
import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"

import EmployeeClassifications from "@/pages/employees/EmployeeClassifications"
import ChargeOutGroups from "@/pages/employees/ChargeOutGroups"
import SettingsUnions from "@/pages/settings/SettingsUnions"
import UnionList from "./UnionList"
import PayAdjustments from "@/pages/employees/PayAdjustments"
import RevenueCodeManagerWidget from "@/components/super_components/RevenueCodeManagerWidget"
import EmployeeMassInvite from "./EmployeeMassInvite"
import PersonnelRolesWidget from "@/components/super_components/PersonnelRolesWidget"
import ContactsImport from "./ContactsImport"
import MaterialImporter from "@/components/material_importer/MaterialImporter";
import SubscriptionChoices from "@/pages/setup_wizard/SubscriptionChoices"
import OnboardingPackages from "@/pages/setup_wizard/OnboardingPackages"

export default {
	name: "SetupWizardComponent",
	components: {
		CollapsiblePanel,
		Field,
		EmployeeClassifications,
		ChargeOutGroups,
		SettingsUnions,
		UnionList,
		PayAdjustments,
		RevenueCodeManagerWidget,
		EmployeeMassInvite,
		PersonnelRolesWidget,
		ContactsImport,
		MaterialImporter,
		SubscriptionChoices,
		OnboardingPackages,
		UploadFieldWithPanel
	},
	props: [
		"sections",
		"questionChangeListener",
		"routeSegment",
		"completeMessage"
	],
	data() {
		return {
			activeSecIndex: 0,
			activeQIndex: 0,
			isComplete: false,
			isShareLink: false,
			tokenExpiry: null,
			
			tempData: {},
			tokenExpiry: null,
			selectedSubscriptionStripeId: null
		}
	},
	watch: {
		questionChangeListener(newIndex,oldIndex) {
			if (newIndex > oldIndex)
				this.nextQuestion()
			else
				this.previousQuestion()
		}
	},
	computed: {	
		subscribeSectionIndex() {
			return this.sections.findIndex(section => section.key == 'subscribe')
		},
		onboardingPackageSectionIndex() {
			return this.sections.findIndex(section => section.key == 'onboardingPackages')
		},
		tokenExpiryTime() {
			let diffMin = this.moment.utc(this.$store.tokenExpiry).local().diff(this.moment(),"minutes")

			if (diffMin > 90)
				return this.moment.utc(this.$store.tokenExpiry).local().diff(this.moment(),"hours")+" hrs"
			else
				return diffMin+" min"
		},
		sectionHasSave() {
			let section = this.sections[this.activeSecIndex]

			if ("questions" in section) {
				let hasSaveEndpoint = section.questions.find(q => "saveEndpoint" in q)

				if (hasSaveEndpoint)
					return true
			}
			return false
		},
		showNextButton() {
			let lastSection = this.sections[this.sections.length - 1]

			if (this.activeSecIndex == this.sections.length - 1 && (!("questions" in lastSection) || lastSection.questions.length - 1 == this.activeQIndex)) 
				//last section, last question or no questions, no next button
				return false
			
			return true
		},
		showFinishButton() {

		}
	},
	methods: {
		shareSection(sectionIndex) {
			let sectionNum = sectionIndex+1

			let vm = this

			let params = {
				scope: JSON.stringify(this.sections[sectionIndex].apiScope),
				expiry_hrs: 48
			}

			this.postData("UserToken/create",params,true).then(response => {
				if (response.success) {
					let token = response.data.token
					vm.$set(this.sections[sectionIndex],"sharing","https://"+window.location.hostname+"/" + vm.routeSegment + "/"+sectionNum+"/"+token)
				}
			})
		},
		initQuestion(secIndex,qIndex) {

			let vm = this
			if (vm.sections[secIndex]) {
				if (!("isCustom" in vm.sections[secIndex]) || !vm.sections[secIndex].isCustom) {
					//set new question
					let question = vm.sections[secIndex].questions[qIndex]

					if ("findEndpoint" in question) {
						vm.fetchSectionData(
							question.findEndpoint,
							question.findParams,
							question.payload,
							"setPayload" in question ? question.setPayload : false
						)
					}
				}
			}
		},
		setQuestion(secIndex,qIndex) {
			let vm = this

			this.$emit("activeSecIndexChange",secIndex)

			//if (this.subscribeSectionIndex > secIndex || this.hasPaidSubscription) {

				let stepNum = secIndex+1 //plus 1 for index
				this.postData("Company/save",{last_setup_step: stepNum})

				if ("isCustom" in vm.sections[vm.activeSecIndex] && vm.sections[vm.activeSecIndex].isCustom) {

					this.activeSecIndex = secIndex
					this.activeQIndex = qIndex

					this.$emit("activeQIndexChange",this.activeQIndex)

					let sectionNum = this.activeSecIndex+1
					window.history.pushState({},"","/"+ vm.routeSegment + "/"+sectionNum)
				}
				else {
					this.saveQuestion(vm.activeSecIndex,vm.activeQIndex).then(response => {
						if (response.success) {
							vm.activeSecIndex = secIndex
							vm.activeQIndex = qIndex

							vm.$emit("activeQIndexChange",vm.activeQIndex)

							let sectionNum = this.activeSecIndex+1
							window.history.pushState({},"","/" + vm.routeSegment + "/" + sectionNum)

							vm.initQuestion(vm.activeSecIndex,vm.activeQIndex)
						}
					})
				}
			//}
		},
		previousQuestion() {
			let vm = this

			let stepNum = vm.activeSecIndex
			this.postData("Company/save",{last_setup_step: stepNum})

			if ("isCustom" in vm.sections[vm.activeSecIndex] && vm.sections[vm.activeSecIndex].isCustom) {
				vm.activeSecIndex--
				vm.activeQIndex = 0
				vm.$emit("activeQIndexChange",vm.activeQIndex)
			}
			else {
				let question = vm.sections[vm.activeSecIndex].questions[vm.activeQIndex]

				this.saveQuestion(vm.activeSecIndex,vm.activeQIndex).then(response => {
					if (response.success) {
						vm.activeQIndex--

						vm.$emit("activeQIndexChange",vm.activeQIndex)

						if (vm.activeQIndex < 0) {
							vm.activeSecIndex--
							vm.activeQIndex = vm.sections[vm.activeSecIndex].questions.length - 1
						}

						let sectionNum = this.activeSecIndex+1
						window.history.pushState({},"","/" + vm.routeSegment + "/" + sectionNum)

						vm.initQuestion(vm.activeSecIndex,vm.activeQIndex)
					}
				})
			}

			this.$emit("activeSecIndexChange",this.activeSecIndex)
		},
		nextQuestion(skipSave) {
			let vm = this


			let stepNum = vm.activeSecIndex+2 //plus 1 for index, and plus 1 for next step we're about to increment
			this.postData("Company/save",{last_setup_step: stepNum})

			if ("isCustom" in vm.sections[vm.activeSecIndex] && vm.sections[vm.activeSecIndex].isCustom) {
				vm.activeSecIndex++
				vm.activeQIndex = 0

				vm.$emit("activeQIndexChange",vm.activeQIndex)

				vm.initQuestion(vm.activeSecIndex,vm.activeQIndex)
			}
			else {


				if (skipSave) {
					vm.activeQIndex++

					if (vm.activeQIndex >= vm.sections[vm.activeSecIndex].questions.length) {
						vm.activeQIndex = 0
						vm.activeSecIndex++
					}

					vm.$emit("activeQIndexChange",vm.activeQIndex)

					let sectionNum = this.activeSecIndex+1
					window.history.pushState({},"","/" + vm.routeSegment + "/" + sectionNum)

					vm.initQuestion(vm.activeSecIndex,vm.activeQIndex)
				}
				else {
					this.saveQuestion(vm.activeSecIndex,vm.activeQIndex).then(response => {
						if (response.success) {
							vm.activeQIndex++

							if (vm.activeQIndex >= vm.sections[vm.activeSecIndex].questions.length) {
								vm.activeQIndex = 0
								vm.activeSecIndex++
							}

							vm.$emit("activeQIndexChange",vm.activeQIndex)
							vm.$emit("activeSecIndexChange",vm.activeSecIndex)

							let sectionNum = this.activeSecIndex+1
							window.history.pushState({},"","/" + vm.routeSegment + "/" + sectionNum)

							vm.initQuestion(vm.activeSecIndex,vm.activeQIndex)
						}
					})
				}
			}
			this.$emit("activeSecIndexChange",this.activeSecIndex)

		},
		finishWizard() {
			let vm = this

			//see if there is anything to save
			if ("questions" in vm.sections[vm.activeSecIndex]) {
				this.saveQuestion(vm.activeSecIndex,vm.activeQIndex).then(response => {
					if (response.success) {
						vm.isComplete = true
						vm.$store.companySetupMode = false

						if (window.innerWidth > 500)
							vm.$bus.$emit("openMainMenu")
					}
				})
			}
			else {
				vm.isComplete = true
				vm.$store.companySetupMode = false

				if (window.innerWidth > 500)
					vm.$bus.$emit("openMainMenu")
			}

			this.postData("Company/save",{setup_finished: 1})
		},
		imageUploaded(response,payload,field) {
			payload[field.vmodel] = response.data
		},
		saveQuestion(sectionIndex,questionIndex) {
			let vm = this

			let question = vm.sections[sectionIndex].questions[questionIndex]

			return new Promise((resolve,reject) => {

				if ("saveEndpoint" in question) {

					let payload = vm.sections[sectionIndex].questions[questionIndex].payload

					if ("mutatedPayload" in vm.sections[sectionIndex].questions[questionIndex])
						payload = vm.sections[sectionIndex].questions[questionIndex].mutatedPayload(payload)

					this.postData(question.saveEndpoint,payload,true).then(response => {
						if (response.success) {
							vm.alertSaved("Progress saved",false)

							resolve(response)
						}
					})
				}
				else if ("tempData" in question && question.tempData) {
					this.tempData[vm.sections[sectionIndex].key] = payload

					resolve({success: true})
				}
			})
		},
		fetchSectionData(endpoint,params,payloadStore,setPayload) {
			let vm = this

			this.getJSON(endpoint,params).then(response => {
				if (response.success) {
					let settedPayload = {}

					if (setPayload) 
						settedPayload = setPayload(response.data)
					
					Object.keys(payloadStore).forEach(key => {
						if (key in settedPayload)
							payloadStore[key] = settedPayload[key]
						else if (key in response.data) 
							payloadStore[key] = response.data[key]
						
					})

					vm.$forceUpdate()
				}
			})
		}
	},
	created() {
		let vm = this

		if ("token" in this.$route.params) {
			localStorage.apiKey = this.$route.params.token
			this.isShareLink = true
		}

		if ("sectionNum" in this.$route.params && this.$route.params.sectionNum > 0) {

			this.activeSecIndex = this.$route.params.sectionNum - 1

			this.$emit("activeSecIndexChange",this.activeSecIndex)

			this.initQuestion(this.$route.params.sectionNum-1,0)
		}
		else
			this.initQuestion(0,0)
	}
}
</script>

<style type="text/css" scoped>
	.wizard-section {
		max-width: 800px;
		margin-left: auto;
		margin-right: auto;
	}

	.list-group h4 {
		text-decoration: none;
		margin: 0
	}

	.list-group-item.active {
		border: 1px solid rgba(0,0,0,.125);
		border-left: 5px solid #28a745;
		background-color: white;
		color: inherit;
	}

	.list-group-item li.active a {
		color: #28a745;
	}

	.list-group-item.disabled a {
		color: gray
	}
</style>